export default {
  SPECIAL_REQUEST: 'SPECIAL_REQUEST',
  MEAL: 'MEAL'
}
